module.exports = __webpack_public_path__ + "static/media/storj.88fa6731.svg";